<script setup lang="ts">
import BootstrapModal from '../bootstrap-modal.vue';

const props = defineProps<{
    message?: string;
}>();
</script>

<template>
    <BootstrapModal
        size="modal-lg"
        close
        hide-footer
    >
        <slot>
            <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <div style="white-space: pre-line;">{{ props.message }}</div>
        </slot>
    </BootstrapModal>
</template>
